import { EnumDescription } from "../decorator/enum-description.decorator";

export class EnumTipoPessoa {
  @EnumDescription("Usuario")
  static usuario = 0;

  @EnumDescription("Estabelecimento")
  static estabelecimento = 1;

}
